module.exports = __webpack_public_path__ + "static/img/icon-1.fbcceac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon-1.png
// module id = u8y8
// module chunks = 7